import {FetchData} from "./fetchData";
import Preloader from '../preloader'

export default class AjaxLink {

  els = {
    link: '[data-js-ajax-link]'
  }

  constructor () {
    this.linksCollection = document.querySelectorAll(this.els.link)
    this.bindEvents()
  }

  async sendRequest(e){
    e.preventDefault()

    let linkData = JSON.parse(e.target.dataset.jsAjaxLink);
    if (linkData.method === 'POST') {
      let ajaxUrl = e.target.closest(this.els.link).dataset.jsAjaxUrl;
      let request = await FetchData.postData(linkData.body, ajaxUrl)
      Preloader.hide()

      return false
    }
    let ajaxUrl = e.target.closest(this.els.link).dataset.jsAjaxUrl;
    let request = await FetchData.getData(ajaxUrl)
    Preloader.hide()
  }

  bindEvents() {
    this.linksCollection.forEach(node => {
      node.addEventListener('click', (e) => this.sendRequest(e))
    })
  }
}
